module.exports = __webpack_public_path__ + "img/Filling_time.35f6d531.svg";